.bo{border:1px solid #ddd;}